export const ORGANIZATION_CHART_COLORS = ["#6577ba", "#5da860", "#c05d3d"];

const TOTAL_METRIC_ALIASES = new Set([
  "total_idps",
  "num_present_idp_ind",
  "num_present_idp",
  "total_present_idps",
]);
const MALE_METRIC_ALIASES = new Set([
  "male_idps",
  "num_present_idp_male",
  "num_present_idp_ind_male",
]);
const FEMALE_METRIC_ALIASES = new Set([
  "female_idps",
  "num_present_idp_female",
  "num_present_idp_ind_female",
]);

const normalizeKey = (value) => String(value ?? "").trim().toLowerCase();

const hashIdentity = (identity) => {
  let hash = 2166136261;
  for (let index = 0; index < identity.length; index += 1) {
    hash ^= identity.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
};

export const getFallbackSeriesColor = (field, value) => {
  const identity = `${normalizeKey(field)}:${normalizeKey(value).replace(/\s+/g, " ")}`;
  return `hsl(${hashIdentity(identity) % 360} 62% 42%)`;
};

export const getSemanticMetricColor = (field) => {
  const normalized = normalizeKey(field);
  if (TOTAL_METRIC_ALIASES.has(normalized)) return ORGANIZATION_CHART_COLORS[0];
  if (MALE_METRIC_ALIASES.has(normalized)) return ORGANIZATION_CHART_COLORS[1];
  if (FEMALE_METRIC_ALIASES.has(normalized)) return ORGANIZATION_CHART_COLORS[2];
  return null;
};

export const getMetricSeriesColor = (field, visibleIndex = 0) =>
  getSemanticMetricColor(field) ||
  ORGANIZATION_CHART_COLORS[visibleIndex] ||
  getFallbackSeriesColor("metric", field);

export const getMetricSeriesColors = (fields) => {
  const safeFields = Array.isArray(fields) ? fields : [];
  const resolved = safeFields.map((field) => getSemanticMetricColor(field));
  const used = new Set(resolved.filter(Boolean));
  return resolved.map((color, index) => {
    if (color) return color;
    const organizationColor = ORGANIZATION_CHART_COLORS.find((candidate) => !used.has(candidate));
    if (organizationColor) {
      used.add(organizationColor);
      return organizationColor;
    }
    return getFallbackSeriesColor("metric", safeFields[index]);
  });
};

export const getTemporalSeriesColor = (field, value, visibleIndex = 0) =>
  ORGANIZATION_CHART_COLORS[visibleIndex] || getFallbackSeriesColor(field, value);